(function () {
  const sticky = document.getElementById('co-sticky-atc');
  const heroForm = document.querySelector('#co-product-form');
  const heroAtc = document.querySelector('#co-product-form .co-btn--atc');
  const stickyBtn = sticky?.querySelector('[data-co-sticky-atc]');
  const productInfo = document.getElementById('co-product-info');

  if (!sticky || !heroAtc) return;

  const syncStickyOffset = () => {
    const height = sticky.classList.contains('is-visible') ? sticky.offsetHeight : 0;
    document.documentElement.style.setProperty('--co-sticky-atc-offset', height + 'px');
  };

  const showSticky = () => {
    sticky.hidden = false;
    requestAnimationFrame(() => {
      sticky.classList.add('is-visible');
      syncStickyOffset();
    });
    document.body.classList.add('co-sticky-atc-active');
  };

  const hideSticky = () => {
    sticky.classList.remove('is-visible');
    document.body.classList.remove('co-sticky-atc-active');
    syncStickyOffset();
    setTimeout(() => {
      if (!sticky.classList.contains('is-visible')) sticky.hidden = true;
    }, 350);
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) hideSticky();
        else showSticky();
      });
    },
    { root: null, threshold: 0, rootMargin: '-80px 0px 0px 0px' }
  );

  observer.observe(heroAtc);

  window.addEventListener('resize', syncStickyOffset);
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(syncStickyOffset).observe(sticky);
  }

  stickyBtn?.addEventListener('click', () => {
    heroAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => heroAtc.click(), 400);
  });
})();
